import React from 'react'
import { Contexts, Types } from '../types'
import _ from 'lodash'
import { useDebug } from '../hooks'

const initialState: any = {
    name: '', // string
    description: undefined, // string|undefined if not set  
    permalink: null,
    images: {
        feature: undefined,
        gallery: []
    }, // string(imageURL)|string[(imageURLsr)]| undefined >> config.defaultImage
    gallery: undefined, // undefined if any 
    type: 'simple', // string
    //stockStatus: 'outofstock', // instock|outofstock, thats question
    //manageStock: true, // boolean
    taxClass: 'standard',  // string
    price: undefined, // undefined if type IN [variable]
    meta: { // Addditional meta
        deliveryTime: undefined, // undefined if not set
    },
    quantity: {
        min: 1,
        selected: 1
    }, // undefined if manageStock == false || isVariable
    purchasable: true,
    available: true,
    // Selected atts list 
}  

// TODO: Base Product provider and child providers for diff product types
// SingleProductContext
// VariableProductContext
// BundledProductContext

export const SimpleProductContext = React.createContext<any>({}) 

const SimpleProductProvider: React.FC<any> = ({ children, config, translations, product, onAddToCart: handleAddToCart }) => {    

    useDebug(`SimpleProductProvider [${product.name}]`)

    const [store, updateStore] = React.useState<any>({...initialState});

    const setState = (key: string, value: any) => {
        if (!(key in initialState)) throw Error(`Key ${key} is not valid state.`);
        if ( store[key] === value ) return;
        updateStore((prevStore: any) => ({ ...prevStore, [key]: value instanceof Function ? value(prevStore[key]) : value, }))
    }

    const productData = React.useMemo(() => _.merge(
        store, 
        product
    ), [product, store]);

    const onAddToCart = React.useCallback(() => {
        handleAddToCart(productData);
    }, [store])

    return (
        <SimpleProductContext.Provider
            value={{
                ...productData,
                config,
                onAddToCart,
                translations,
                setState,
            }}
            children={ ! _.isEmpty(productData) ? children : null}
        />
    )
}

export default SimpleProductProvider;